import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Navigation from './infrastructure/Navigation';

ReactDOM.render(
  <React.StrictMode>
    <Navigation/>
  </React.StrictMode>,
  document.getElementById('root')
);

